import React, { useState, useCallback, useEffect, useRef } from "react";
import { convertDateType, getBeforeDate } from './utils/ServiceCalendarUtils';
import './servicecalendar.css';

export const Search = ({ 
    scheduler,
    startDate,
    intervalMonths,
    onSelectMonths,
    onSelectStartDate,
    onShowColorsPopup,
    onShowFilterPopup
}) => {
    const showColorsButtonRef = useRef(null);
    const showFilterButtonRef = useRef(null);

    const [position, setPosition] = useState(0);
    const [events, setEvents] = useState([]);
    const [phrase, setPhrase] = useState(null);
    const [selectedDate, setSelectedDate] = useState(startDate.toISOString().split("T")[0]);
    const [selectedCompare, setSelectedCompare] = useState("bigger");
    const [selectedMonths, setSelectedMonths] = useState(intervalMonths);
    const [showColorsPopup, setShowColorsPopup] = useState(false);
    const [showFilterPopup, setShowFilterPopup] = useState(false);

    useEffect(() => {
        const eventList = scheduler.events.list;
        setEvents(eventList);
    }, []);

    useEffect(() => {
        setSelectedDate(startDate.toISOString().split("T")[0]);
    }, [startDate]);

    useEffect(() => {
        setSelectedMonths(intervalMonths);
    }, [intervalMonths]);

    const handleSelectedMonths = (months) => {
        if (selectedCompare == 'equals') {
            setSelectedMonths(1);
            onSelectMonths(1);
        }
        else if (selectedCompare == 'bigger') {
            onSelectStartDate(new Date(selectedDate));
            onSelectMonths(months);
            setSelectedMonths(months);  
        }
        else {
            onSelectStartDate(new Date(getBeforeDate(selectedDate, months)));
            onSelectMonths(months);
            setSelectedDate(new Date(selectedDate));
            setSelectedMonths(months);
        }
    }

    const handleSelectedStartDate = (date) => {
        onSelectStartDate(new Date(date));
        setSelectedDate(new Date(date).toISOString().split("T")[0]);
    }

    const handleShowColorsPopup = (show) => {
        const rect = showColorsButtonRef.current.getBoundingClientRect();
        onShowColorsPopup(show, rect.x - 20, rect.y + 120);
        setShowColorsPopup(show);
    }

    const handleShowFilterPopup = (show) => {
        const rect = showFilterButtonRef.current.getBoundingClientRect();
        onShowFilterPopup(show, rect.x - 220, rect.y + 120);
        setShowFilterPopup(show);
    }

    const search = (ev) => {
        const phrase = ev.target.value;
        const foundEvents = scheduler.events.findAll(e => e.data.text.toLowerCase().includes(phrase.toLowerCase()));
        setPhrase(phrase);
        setEvents(foundEvents);
        setPosition(0);
        if (foundEvents.length > 0) {
            scheduler.update({ events: scheduler.events.list });
            scheduler.events.scrollIntoView(foundEvents[0]);
        }
    };
    
    const handleSelectedCompare = (e) => {
        setSelectedCompare(e.target.value);
        if (e.target.value == 'equals') {
            setSelectedMonths(1);
            onSelectMonths(1);
        }
        else if (selectedCompare == 'bigger') {
            onSelectStartDate(new Date(selectedDate));
            onSelectMonths(selectedMonths);
            setSelectedMonths(selectedMonths);  
        }
        else {
            onSelectStartDate(new Date(getBeforeDate(selectedDate, selectedMonths)));
            onSelectMonths(selectedMonths);
            setSelectedDate(new Date(selectedDate));
            setSelectedMonths(selectedMonths);
        }
    }

    const previous = useCallback(() => {
        if (events.length < 1) {
            return;
        }
        setPosition(prevPosition => {
            const newPosition = prevPosition - 1 < 0 ? events.length - 1 : prevPosition - 1;
            scheduler.events.scrollIntoView(events[newPosition]);
            return newPosition;
        });
    }, [events, scheduler]);

    const next = useCallback(() => {
        if (events.length < 1) {
            return;
        }
        setPosition(prevPosition => {
            const newPosition = prevPosition + 1 > events.length - 1 ? 0 : prevPosition + 1;
            scheduler.events.scrollIntoView(events[newPosition]);
            return newPosition;
        });
    }, [events, scheduler]);

    return (
        <div style={{ display: "flex", alignItems: "center" }} className="space">
            {/* Search:
            &nbsp;
            <input onChange={e => search(e)} /> */}
            &nbsp;
            Date
            &nbsp;
            <select value={selectedCompare} onChange={(e) => handleSelectedCompare(e) } className="select-compare-sign">
                <option value="equals">&#61;</option>
                <option value="bigger">&gt;</option>
                <option value="smaller">&lt;</option>
            </select>
            &nbsp;
            <input
                type="date"
                value={selectedDate}
                onChange={(e) => handleSelectedStartDate(e.target.value)}
                style={{
                    width: '7em',
                    height: '25px'
                }}
            />            
            &nbsp;
            <button
                title="Previous"
                onClick={previous}
                className="next-previous"
            >
                <svg width={18} height={18}>
                    <use href="icons/daypilot.svg#minichevron-left-2" />
                </svg>
            </button>
            &nbsp;
            <button
                title="Next"
                onClick={next}
                className="next-previous"
            >
                <svg width={18} height={18}>
                    <use href="icons/daypilot.svg#minichevron-right-2" />
                </svg>
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Show
            &nbsp;
            <select value={selectedMonths} onChange={(e) => handleSelectedMonths(parseInt(e.target.value))} className="select-months" style={{ height: '25px' }}>
                <option value="1">1</option>
                <option value="2" selected>2</option>
                <option value="3">3</option>
                <option value="6">6</option>
                <option value="9">9</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>
                <option value="36">36</option>
            </select>
            &nbsp;
            Months
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button
                onClick={(e) => handleShowFilterPopup(!showFilterPopup)}
                className="btn-filter"
                ref={showFilterButtonRef}
            >
                Filter
            </button>
            &nbsp;&nbsp;&nbsp;
            <button
                onClick={(e) => handleShowColorsPopup(!showColorsPopup)}
                className="btn-filter"
                ref={showColorsButtonRef}
            >
                Show Colors
            </button>

        </div>
    );
};
